export const LOYALTY_HISTORY_SLICE_NAME = 'gygLoyaltyHistory'

export const GET_LOYALTY_HISTORY_BY_USER_ID_ACTION = `${LOYALTY_HISTORY_SLICE_NAME}/getLoyaltyHistoryByUserId`
